import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/meemo/Interview/'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import CaseStudy from 'components/home/CaseStudy'
import {
  firstViewItem,
  overviewTitle,
  overviewItem,
  issueSolutionItems,
  caseCTAItem,
  caseDownloadCTAItem,
} from './MeemoItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import CaseDownloadCTA from 'components/cases/common/CaseDownloadCTA'
import FooterCTA from 'components/common/FooterCTA'
import styles from './Meemo.module.scss'

const Meemo = () => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <CaseDownloadCTA {...caseDownloadCTAItem} />
      <FooterCTA />
      <div className={styles.mobileAppWrapper}>
        <MobileAppDevelopment />
      </div>
      <div className={styles.line}>
        <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
      </div>
    </section>
  )
}

export default Meemo
